/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Fulfillment = {
  readonly id?: number;
  supporting_due_date?: string | null;
  model_status?: Fulfillment.model_status | null;
  company_measurement_date: number;
  reviewers?: Array<number>;
  preparers?: Array<number>;
  readonly attio_valuation_id?: string;
  is_slc_model?: boolean;
  is_waiting?: boolean;
  is_rush_deal?: boolean;
};
export namespace Fulfillment {
  export enum model_status {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
  }
}

